import { Mail, Network } from 'lucide-react';

import OnesuranceIcon from '@/components/icons/Onesurance';
import type { Action } from '@/types/actions';

type Props = {
  title: string;
  source: Action['source'];
};

export default function ActionChip({ title, source }: Props) {
  return (
    <span className="border-primary-200 text-primary-950 inline-flex items-center gap-1 rounded-md border bg-white/80 px-1.5 py-0.5 align-middle text-xs">
      {source === 'EMAIL' && (
        <Mail className="text-primary-600 size-3 shrink-0" strokeWidth={2.5} />
      )}
      {source === 'PARTY_CHECKUP' && (
        <Network
          className="text-primary-600 size-3 shrink-0"
          strokeWidth={2.5}
        />
      )}
      {source === 'ONESURANCE' && (
        <OnesuranceIcon className="text-primary-600 size-3 shrink-0" />
      )}

      {title}
    </span>
  );
}
